<template>
  <div class="coming-soon-layout">
    <div class="coming-soon">
      <p>{{ $i18nPresenter.t('Coming soon to this slide!') }}</p>
      <p>{{ $i18nPresenter.t('In the meantime, try enhancing your Content slides with this exciting feature 🤩') }}</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.coming-soon-layout {
  @apply w-full h-full bg-base-0 z-10 absolute -top-5 left-0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 1) 40%);
  .coming-soon {
    @apply flex flex-col h-full justify-center items-center text-center px-4;
  }
}
</style>
